// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"763ffed5","126":"08ea7474","200":"38344e74","254":"f01c6146","360":"035a52ef","372":"233fd163","538":"5c9f4e1b","815":"7411e3bf","855":"f76574bf"}[chunkId] + ".chunk.js";
};